import { defineAsyncComponent } from 'vue';

export const LazyCollectionListingDrawer = defineAsyncComponent(() => import('./components/Collection/CollectionListingDrawer.vue'));
export const LazyCollectionDetailDrawer = defineAsyncComponent(() => import('./components/Collection/CollectionDetailDrawer.vue'));
export const LazyCollectionPickerDrawer = defineAsyncComponent(() => import('./components/Collection/CollectionPickerDrawer.vue'));
